/** Contains styles for tables */
import { Box, styled } from "@mui/material";

export const TableWrapper = styled(Box)(({ theme }) => ({
	marginTop: theme.spacing(5),
	marginBottom: theme.spacing(5),
}));